<template>
    <div class="cont-table-ads-jm">

        <div class="spin">
            <ion-spinner name="crescent"></ion-spinner>
        </div>



        <div class="row cont_annunci_jobmule">
            <div class=" " style="margin:0 auto;">
                <div class="card">

                    <div class="card-body" style="padding:0px">

                        <div class="table-responsive" style="">

                            <table id="myTable">
                                <thead>
                                    <tr>

                                        <th class='all'>
                                            <div class="cl_checkall">
                                                <ion-checkbox name='emailgestoreall'
                                                    style="width:10px!important;height:10px!important" class='checkall'
                                                    slot='start'>
                                                </ion-checkbox>
                                            </div>
                                        </th>
                                        <th class='all'>
                                            <div class='cl_num'>N.</div>
                                        </th>
                                        <th class='desktop cl-title-center'>Stato</th>
                                        <th class='desktop cl-title-center'>Featured</th>
                                        <th class='all'>Codice</th>
                                        <th class='all'>Data Ins.</th>
                                        <th class='desktop'>Data Scad.</th>
                                        <th class='desktop'>Azienda</th>
                                        <th class='all'>Titolo</th>
                                        <th class='desktop'>Descrizione</th>
                                        <th class='desktop'>Regione</th>
                                        <th class='desktop'>Provincia</th>
                                        <th class='desktop'>Comune</th>
                                        <th class='desktop'>Tipo Contratto</th>
                                        <th class='desktop'>Durata</th>

                                        <th class='desktop'>Tipo Lavoro</th>

                                        <th class='desktop cl-title-center'>Candidature</th>

                                    </tr>
                                </thead>

                                <tfoot>

                                    <tr>
                                        <th colspan="17">
                                        </th>
                                    </tr>
                                </tfoot>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetChangeStatus">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetChangeStatus = !sheetChangeStatus">
                        <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_jobmule.png" max-width="30"
                            max-height="30" transition="scale-transition" style="margin-right:20px!important" />
                    </v-btn>
                    <div class="py-3">
                        Cambia stato in
                    </div>
                    <v-list-item v-for="tile in allStatus" :key="tile.value" @click="changeStatus(tile.value)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.description
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetFilterStatus">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetFilterStatus = !sheetFilterStatus">
                        <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_jobmule.png" max-width="30"
                            max-height="30" transition="scale-transition" style="margin-right:20px!important" />
                    </v-btn>
                    <div class="py-3">
                        Filtro stato
                    </div>
                    <v-list-item v-for="tile in allFilterStatus" :key="tile.value"
                        @click="changeFilterStatus(tile.value)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.description
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="contpopuphistory" style="display:none">

            <template>
                <modal name="popupHistory" :clickToClose="false" :width="350" :height="400">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Storico Clienti

                        </v-col>

                    </v-row>

                    <v-row>
                        <v-col cols="12" md="12">

                            <table style="margin-left:11px">
                                <thead>
                                    <tr>
                                        <th style="padding:5px 5px 5px 5px;width:95px">Nome</th>
                                        <th style="padding:5px 5px 5px 5px;width:95px">Referente</th>
                                        <th style="padding:5px 5px 5px 5px">Data</th>
                                        <th style="padding:5px 5px 5px 5px">Stato</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="cust in customers_history" :key="cust.id">
                                        <td style="padding:5px 5px 5px 5px;width:95px">{{ cust.fld_name }}</td>
                                        <td style="padding:5px 5px 5px 5px;vertical-align:top;width:95px">
                                            {{ cust.referente }}</td>
                                        <td style="padding:5px 5px 5px 5px;vertical-align:top">{{ cust.data }}</td>
                                        <td style="padding:5px 5px 5px 5px;vertical-align:top">{{ cust.description }}
                                        </td>
                                    </tr>
                                </tbody>



                            </table>





                        </v-col>


                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-history" contain src="@/assets/btn_cancel3.png"
                                    max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;transform:translateY(218px)"
                                    transition="scale-transition" title="Annulla" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupsearch" style="display:none">

            <template>
                <modal name="popupSearch" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            <v-img alt="" src="@/assets/jobmule_ricerca3.png" max-width="25" max-height="25" />

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="textSearch" label=""
                                style="font-size:11px;color:black;font-weight:bold">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-search" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" />

                                <v-img alt="" class="btn-confirm-search" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>



        <div class="contpopupmail" style="display:none">

            <template>
                <modal name="popupMail" :clickToClose="false" :width="300" :height="500">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Anteprima Mail

                        </v-col>

                    </v-row>

                    <v-row style="margin-left:5px!important">

                        <v-col cols="12" md="12">

                            <textarea id="sec_body" name="sec_body" class="sec_body" autofocus
                                style="width:270px!important;height:400px!important"></textarea>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-mail" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" />

                                <v-img alt="" class="btn-view-ads" contain src="@/assets/ads_mail.png" max-width="25"
                                    max-height="25" style="cursor:pointer;margin-right:10px;margin-top:3px"
                                    transition="scale-transition" title="Annunci Selezionati" />

                                <v-img alt="" class="btn-confirm-mail" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupads" style="display:none">

            <template>
                <modal name="popupAds" :clickToClose="false" :width="300" :height="500">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Annunci

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="height:358px!important;width:100%!important;overflow-y:auto!important">

                                <table style="width:100%">
                                    <thead>
                                        <tr>
                                            <th style="width:10%;padding-left:7px">&nbsp;</th>
                                            <th style="width:25%">Codice</th>
                                            <th style="width:65%">Annuncio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="v_ads in listAds" :key="v_ads.number_ads">
                                            <td style="padding-top:5px;padding-left:7px;vertical-align:top!important">
                                                <input type='checkbox' class='val_status_ads'
                                                    :value="v_ads.number_ads" />
                                            </td>
                                            <td style="padding-top:5px;vertical-align:top!important">{{ v_ads.number_ads
                                            }}</td>
                                            <td style="padding-top:5px;vertical-align:top!important">{{ v_ads.title }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>


                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-ads" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" />

                                <v-img alt="" class="btn-confirm-ads" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_jobmule.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/aziende-jobmule.png" max-width="24"
                                            max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.companyname }}
                                        </v-list-item-title>

                                    </v-list-item>
                                </v-card>
                            </v-flex>

                            <div style="min-height:170px;height:170px">&nbsp;</div>



                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>

        <div class="contpopupcopytoclipboard" style="display:none">

            <template>
                <modal name="popupCopyToClipboard" :clickToClose="false" :width="300" :height="195">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;margin-left:10px;font-size: 11px;color:black">

                            Copy Url Ads To Clipboard

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="urlSelected" id="url_selected" label="Url" ref="textToCopy"
                                style="font-weight:bold;font-size:11px;color:black">
                            </v-text-field>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-copy-clip" contain
                                    src="@/assets/btn_cancel3_jobmule.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" />

                                <v-img alt="" class="btn-confirm-copy-clip" contain
                                    src="@/assets/btn_confirm3_jobmule.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="copyText" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupenable" style="display:none">

            <template>
                <modal name="popupEnable" :clickToClose="false" :width="300" :height="195">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Abilita

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">



                            <v-list style="overflow-y:auto;max-height: 85px!important;min-height: 85px!important">


                                <v-list-tile v-for="el in aziende_enable" :key="el.companyid">


                                    <div class="contCheck">

                                        <div>
                                            <v-checkbox v-model="idsAziSel" multiple class="cl-checkbox"
                                                :value="el.companyid" />
                                        </div>

                                        <div style="margin-top:-5px;">{{ el.companyname }}</div>



                                    </div>


                                </v-list-tile>



                            </v-list>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-enable" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelFuncEnable" />

                                <v-img alt="" class="btn-confirm-enable" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmFuncEnable" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupdisable" style="display:none">

            <template>
                <modal name="popupDisable" :clickToClose="false" :width="300" :height="195">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Disabilita

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">


                            <v-list style="overflow-y:auto;max-height: 85px!important;min-height: 85px!important">


                                <v-list-tile v-for="el in aziende_enable" :key="el.companyid">


                                    <div class="contCheck">

                                        <div>
                                            <v-checkbox v-model="idsAziSel" multiple class="cl-checkbox"
                                                :value="el.companyid" />
                                        </div>

                                        <div style="margin-top:-5px;">{{ el.companyname }}</div>



                                    </div>


                                </v-list-tile>



                            </v-list>




                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-enable" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelFuncDisable" />

                                <v-img alt="" class="btn-confirm-enable" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmFuncDisable" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>

        <div class="contpopupfeatured" style="display:none">

            <template>
                <modal name="popupFeatured" :clickToClose="false" :width="300" :height="195">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Featured

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">


                            <v-list style="overflow-y:auto;max-height: 85px!important;min-height: 85px!important">


                                <v-list-tile v-for="el in aziende_enable" :key="el.companyid">


                                    <div class="contCheck">

                                        <div>
                                            <v-checkbox v-model="idsAziSel" multiple class="cl-checkbox"
                                                :value="el.companyid" />
                                        </div>

                                        <div style="margin-top:-5px;">{{ el.companyname }}</div>



                                    </div>


                                </v-list-tile>



                            </v-list>





                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-enable" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelFuncFeatured" />

                                <v-img alt="" class="btn-confirm-enable" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="32" max-height="32" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmFuncFeatured" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>



        <div class="contpopupnotfeatured" style="display:none">

            <template>
                <modal name="popupNotFeatured" :clickToClose="false" :width="300" :height="195">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Not Featured

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-list style="overflow-y:auto;max-height: 85px!important;min-height: 85px!important">


                                <v-list-tile v-for="el in aziende_enable" :key="el.companyid">


                                    <div class="contCheck">

                                        <div>
                                            <v-checkbox v-model="idsAziSel" multiple class="cl-checkbox"
                                                :value="el.companyid" />
                                        </div>

                                        <div style="margin-top:-5px;">{{ el.companyname }}</div>



                                    </div>


                                </v-list-tile>



                            </v-list>


                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-enable" contain src="@/assets/btn_cancel3_jobmule.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelFuncNotFeatured" />

                                <v-img alt="" class="btn-confirm-enable" contain src="@/assets/btn_confirm3_jobmule.png"
                                    max-width="32" max-height="32" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmFuncNotFeatured" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>

        <modal-table-selector v-model="openDialog" :title="titleSelectElement" :items="itemList"
            :selected-id="selectedId" @confirm="handleConfirm" @cancel="handleCancel" @refresh="loadData"
            :width="widthWindow" :height="heightWindow" draggable />



    </div>
</template>

<script>
import apicandidate from "../utils/candidate/apicandidate";
import apiads from "../utils/ads/apiads";
import ModalTableSelector from "@/components/ModalTableSelector.vue";
import apisottocategorie from "../utils/sottocategorie/apisottocategorie";

import {
    bus
} from "../main";
import router from ".././router";

import $ from 'jquery';

$.fn.numberFormat = function (decimals = 2, decPoint = ',', thousandsSep = '.') {
    return this.each(function () {
        let raw = $(this).text().trim()

        // Converti da "4.468,20" o "4468,2" a "4468.2"
        let val = raw.replace(/\./g, '').replace(',', '.')

        if (!isFinite(val)) return

        let n = parseFloat(val)
        let fixed = n.toFixed(decimals)

        let parts = fixed.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)
        let formatted = parts.join(decPoint)

        $(this).text(formatted)
    })
}


export default {
    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
    },

    mounted: function () {
        /*     let self = this;
        fetch('https://jsonplaceholder.typicode.com/posts')
          .then(response => response.json())
          .then(json => self.$data.items = json) */

        //var res = apiprofile.getProfile(1,2);

        /*eslint-disable no-undef*/

        // Vue.use(VModal, {
        //     dialog: true
        // });


        window.perpage = 30;
        bus.$off("bottomIconClickEvent");

        var pointerVue = this;

        //window.idStatus = 1; // default abilitati
        window.idStatus = ""; // default tutti

        window.curSrcText = "";

        window.curProd = "Jobmule";

        $(document).ready(
            function () {

                $("body").off();

                window.uname = window.$cookies.get("username");
                var uname = window.uname;

                const args = [uname, true, ['bar', 5], {
                    foo: 'baz'
                }];
                try {
                    console.log("entering user");
                    window.flutter_inappwebview.callHandler('setLoggedUser', ...args);
                    console.log("passed");

                } catch (error) {
                    // alert(error);
                }

            }
        );

        $(document).ready(function () {



            $('body').on('ionChange', '.idCompany', function () {

                console.log(("EVENTO CLICK IDCOMPANY"));

                pointerVue.idCompanyEnable = this.value;

            });

            $('body').on('ionChange', '.idCompanyDis', function () {

                console.log(("EVENTO CLICK IDCOMPANYDIS"));

                pointerVue.idCompanyDisable = this.value;

            });

            $('body').on('ionChange', '.idCompanyFeat', function () {

                console.log(("EVENTO CLICK IDCOMPANYFEAT"));

                pointerVue.idCompanyFeatured = this.value;

            });

            $('body').on('ionChange', '.idCompanyNotFeat', function () {

                console.log(("EVENTO CLICK IDCOMPANYNOTFEAT"));

                pointerVue.idCompanyNotFeatured = this.value;

            });


            $('body').on('ionChange', '.selstato', function () {

                console.log(("EVENTO CLICK SELSTATO"));

                window.idStatus = this.value;

                pointerVue.hideShowButtons(false);

                pointerVue.showSpinner = true;
                pointerVue.$root.$children[0].showProgress = true;

                window.table.ajax.reload();

            });


            $('body').on('click', '.btn-view-ads', function () {

                console.log(("EVENTO CLICK BTN_VIEW_ADS"));

                tinymce.remove();

                pointerVue.$modal.hide('popupMail');

                pointerVue.returnToAds();

            });




            $('body').on('click', '.btn-cancel-copy-clip', function () {

                console.log(("EVENTO CLICK BTN_CANCEL_COPY_CLIP"));

                pointerVue.$modal.hide('popupCopyToClipboard');

            });




            $('body').on('click', '.btn-cancel-ads', function () {

                console.log(("EVENTO CLICK BTN_CANCEL_ADS"));

                pointerVue.$modal.hide('popupAds');

            });


            $('body').on('click', '.btn-confirm-ads', function () {

                console.log(("EVENTO CLICK BTN_CONFIRM_ADS"));

                var tot = 0;
                var ids = "";

                $(".val_status_ads").each(function (index) {

                    console.log(index);

                    if ($(this).prop("checked")) {

                        tot = tot + 1;

                        if (ids != "") {
                            ids = ids + ",";
                        }
                        ids = ids + $(this).val();
                    }

                });

                console.log("TOT: ", tot);
                console.log("ANN SEL: ", ids);

                if (tot > 0) {

                    pointerVue.idAdsSel = ids;

                    pointerVue.$modal.hide('popupAds');

                    pointerVue.loadPreview();

                }
                else {

                    pointerVue.$swal({
                        icon: "error",
                        text: "Selezionare degli annunci",
                        showConfirmButton: false,
                        timer: 2000
                    });

                }



            });



            $('body').on('click', '.btn-confirm-mail', function () {

                console.log(("EVENTO CLICK BTN_MAIL"));

                pointerVue.sendMail();

            });


            $('body').on('click', '.btn-cancel-mail', function () {

                console.log(("EVENTO CLICK BTN_CANCEL_MAIL"));

                tinymce.remove();

                pointerVue.$modal.hide('popupMail');

            });



            $('body').on('click', '.selaggiorna', function () {

                console.log(("EVENTO CLICK SELAGGIORNA"));

                pointerVue.showSpinner = true;
                pointerVue.$root.$children[0].showProgress = true;

                window.table.ajax.reload();

            });



            $('body').on('click', '#footer-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openLcHandler', ...args);

                return false;
            });


            $('body').on('click', '#privacy-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openPrivacyHandler', ...args);

                return false;
            });

            $('body').on('click', '#hdtool-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openHdHandler', ...args);

                return false;
            });


            $('body').on('click', '.checkall', function () {


                $(".val_status").prop("checked", $(this).prop("checked"));

                console.log("CHECKALL: ", $(this).prop("checked"));


                if ($(this).prop("checked")) {

                    $("tr").addClass("active-row");

                    $("tr").eq(0).removeClass("active-row");

                }

                if (!$(this).prop("checked")) {

                    $("tr").removeClass("active-row");


                }

                pointerVue.hideShowButtonsSelRow();


            });

            $('body').on('click', '.btn-cancel-history', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupHistory');

            });

        });

        setTimeout(() => {
            this.initFilter();
        }, 100);
        // console.log (res);

        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);

            var ids = "";

            switch (data) {

                case "btn_delete":


                    this.deleteRow();

                    break;

                case "btn_exit":
                    router.push({
                        path: "/dash"
                    });
                    break;

                case "btn_add":

                    var a = window.$cookies.get("a");
                    var b = window.$cookies.get("b");

                    if ((a == 'N') && (b == 'N')) {

                        //this.checkGroupReceiveCVOnInsert();

                        router.push({
                            path: "/editAnnuncio/0"
                        });

                    }
                    else { // su or admin company

                        router.push({
                            path: "/editAnnuncio/0"
                        });

                    }

                    break;




                case "btn_edit":



                    var a2 = window.$cookies.get("a");
                    var b2 = window.$cookies.get("b");

                    if ((a2 == 'N') && (b2 == 'N')) {

                        //this.checkGroupReceiveCVOnEdit();

                        ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);

                        router.push({
                            path: "/editAnnuncio/" + ids
                        });

                    }
                    else { // su or admin company

                        ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);

                        router.push({
                            path: "/editAnnuncio/" + ids
                        });

                    }





                    break;

                case "btn_copy_to_clipboard":

                    var val_url = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            val_url = $(this).attr("url-value");

                        }

                    });

                    console.log("URL VALUE: ", val_url);

                    this.urlSelected = val_url;

                    var that = this;

                    setTimeout(() => {

                        $(".contpopupcopytoclipboard").show();

                        that.$modal.show('popupCopyToClipboard');

                    }, 200);



                    break;

                case "btn_enable":

                    this.idCompanyEnable = null;

                    this.idsAziSel = [];

                    $(".contpopupenable").show();

                    this.$modal.show('popupEnable');

                    break;

                case "btn_disable":

                    this.idCompanyEnable = null;

                    this.idsAziSel = [];

                    $(".contpopupdisable").show();

                    this.$modal.show('popupDisable');

                    break;

                case "btn_featured":

                    this.idCompanyFeatured = null;

                    this.idsAziSel = [];

                    $(".contpopupfeatured").show();

                    this.$modal.show('popupFeatured');

                    break;

                case "btn_normal":

                    this.idCompanyNotFeatured = null;

                    this.idsAziSel = [];

                    $(".contpopupnotfeatured").show();

                    this.$modal.show('popupNotFeatured');

                    break;


                case "btn_copy":

                    this.cloneAds();

                    break;

                case "btn_candidature":

                    ids = "";

                    var title_ads = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");

                            title_ads = $(this).attr("title-ads");

                        }

                    });

                    console.log("IDS SEL:", ids);

                    console.log("TITLE ADS:", title_ads);

                    window.$cookies.set("title_ads_candidature", title_ads, "9y");

                    router.push({
                        path: "/annunciCandidati/" + ids
                    });


                    break;

                default:
                    break;

            }
        });

        // this.setupButtons();

        this.setupButtonsGrid();

        //wait loading
        /* var v_token = window.$cookies.get("token");
        var v_company = window.$cookies.get("sel_filter_azienda_utenti"); */
        window.start_ = 0;
        //console.log("DOMAIN: " + pointerVue.getUrlDomain("getListingRSA"));

        // console.log("HOSTNAME: " + $(location).attr('hostname'));
        // console.log("PROTOCOL: " + $(location).attr('protocol'));
        //var pointerVue = this;

        /*         $.ajax({
                    url: pointerVue.getUrlDomain("getUtenti") + '?username=' + v_token + "&company=" + v_company,
                    data: {

                        currDay: window.currDay,
                        currDayTo: window.currDayTo,
                        curStatus: window.curStatus,
                        curPiano: window.curPiano,
                        start: window.start,
                        length: 30,

                    },
                    success: function (dati) {

                        window.dataset = dati.data;
                        window.loading = 0;
                        window.start = +30;
                        pointerVue.setupGrid();

                    }
                }); */

        /*  window.loading = 0;
         window.start = +30; */
        pointerVue.setupGrid();

        this.hideShowButtons(false);

        setTimeout(() => {

            $('thead th:first div span').addClass('no-before');

            $('.dt-type-numeric').removeClass('dt-type-numeric');


        }, 800);


    },
    data: () => ({

        idAziendaSearch: "",

        titleSelectElement: "",

        selectedId: null,

        heightWindow: 0,
        widthWindow: 0,

        openDialog: false,
        itemList: [],

        idCompanyEnable: null,
        idCompanyDisable: null,
        idCompanyFeatured: null,
        idCompanyNotFeatured: null,

        urlSelected: "",

        sheetAziende: false,
        search: "",

        sheetAziendeEnable: false,
        searchAziendeEnable: "",

        idsAziSel: [],


        idAdsSel: "",
        mailToAds: "",

        listAds: [],

        aziende: [],

        aziende_enable: [],
        aziende_disable: [],
        aziende_featured: [],
        aziende_notfeatured: [],


        textSearch: "",

        row_selected: null,


        sheetChangeStatus: false,
        sheetFilterStatus: false,

        customers_history: [],


        allStatus: [],
        allFilterStatus: [],

        showPicker: false,
        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) =>
                (v && v.length <= 16) ||
                "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) =>
                (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [(v) => !!v || "Field required"],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,
    }),

    computed: {

        filteredAziende() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.companyname.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')
        },

        filteredAziendeEnable() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.searchAziendeEnable) return this.aziende;
                return (item.companyname.toLowerCase().includes(this.searchAziendeEnable.toLowerCase()));
            }), 'headline')
        },

    },

    components: {
        ModalTableSelector,
    },

    methods: {

        getUrlDomainGo: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4007/";
            }

            if (location.hostname != "localhost") {

                result = "https://filestransfer.it:4007/";

            }

            return result + nome_metodo;

        },

        refreshTable: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");


            if (that.titleSelectElement == "Azienda") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response = await apisottocategorie.getCompanyJobmule(
                    v_token
                ).then((res) => {

                    console.log("res from getCompanyJobmule", res);

                    setTimeout(() => {



                        var Aziende = [];


                        for (var x = 0; x < res.data.Result.length; x++) {

                            if (res.data.Result[x].fld_name != null) {

                                Aziende.push({
                                    id: res.data.Result[x].companyid,
                                    descrizione: res.data.Result[x].fld_name
                                });

                            }



                        }

                        that.itemList = Aziende;



                        console.log("ITEM LIST: ", that.itemList);


                        that.selectedId = "";

                        if (that.idAziendaSearch != "") {

                            that.selectedId = parseInt(that.idAziendaSearch);

                        }

                        console.log("SEL ID CLIENTE: ", that.selectedId);

                        setTimeout(() => {

                            that.$root.$children[0].showProgress = false;


                        }, 200);


                    }, 200);


                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response);

                }

                );


            }


        },

        loadData() {

            this.refreshTable();

        },


        handleConfirm(item) {

            console.log("ITEM: ", item);


            var that = this;

            var errore = "";

            if (item == null) {
                errore = "Selezionare un elemento";
            }

            if (errore == "") {

                console.log("ok");

                if (that.titleSelectElement == "Azienda") {

                    that.idAziendaSearch = item.id;

                    that.selectedId = item.id;

                    that.nomeAzienda = item.descrizione;

                    that.$modal.hide('popupSelectElement');

                    window.idCompany = item.id;

                    that.hideShowButtons(false);

                    that.showSpinner = true;
                    that.$root.$children[0].showProgress = true;

                    window.table.ajax.reload();

                }



            }
            else {
                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 3000
                });
            }

        },

        handleCancel() {
            console.log("Annullato");
        },

        openPopupAziende: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getCompanyJobmule(
                v_token
            ).then((res) => {

                console.log("res from getCompanyJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Azienda";

                    var Aziende = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].fld_name != null) {

                            Aziende.push({
                                id: res.data.Result[x].companyid,
                                descrizione: res.data.Result[x].fld_name
                            });

                        }



                    }

                    that.itemList = Aziende;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.idAziendaSearch != "") {

                        that.selectedId = parseInt(that.idAziendaSearch);

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        checkGroupReceiveCVOnEdit: async function () {


            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);


            var that = this;

            console.log("AZIENDE: ", that.aziende);

            console.log("ID AZIENDA: ", that.aziende[1].companyid);

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiads.checkGroupReceiveCV(
                that.aziende[1].companyid
            ).then(async (res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from checkGroupReceiveCV", res);

                if (res.data.Result == "OK") {





                    router.push({
                        path: "/editAnnuncio/" + ids
                    });






                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 4000
                    });


                }


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }


            );




        },






        checkGroupReceiveCVOnInsert: async function () {

            var that = this;

            console.log("AZIENDE: ", that.aziende);

            console.log("ID AZIENDA: ", that.aziende[1].companyid);

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiads.checkGroupReceiveCV(
                that.aziende[1].companyid
            ).then(async (res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from checkGroupReceiveCV", res);

                if (res.data.Result == "OK") {


                    router.push({
                        path: "/editAnnuncio/0"
                    });

                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 4000
                    });


                }


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }


            );




        },



        btnConfirmFuncEnable: function () {

            console.log("AZI SEL: ", this.idsAziSel);

            if (this.idsAziSel.length > 0) {

                console.log("ok");

                this.enableAds();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare le aziende",
                    showConfirmButton: false,
                    timer: 2000
                });


            }

        },

        btnConfirmFuncDisable: function () {


            console.log("AZI SEL: ", this.idsAziSel);

            if (this.idsAziSel.length > 0) {

                console.log("ok");

                this.disableAds();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare le aziende",
                    showConfirmButton: false,
                    timer: 2000
                });


            }

        },

        btnConfirmFuncFeatured: function () {


            console.log("AZI SEL: ", this.idsAziSel);

            if (this.idsAziSel.length > 0) {

                console.log("ok");

                this.featuredAds();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare le aziende",
                    showConfirmButton: false,
                    timer: 2000
                });


            }



        },


        btnConfirmFuncNotFeatured: function () {

            console.log("AZI SEL: ", this.idsAziSel);

            if (this.idsAziSel.length > 0) {

                console.log("ok");

                this.notFeaturedAds();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare le aziende",
                    showConfirmButton: false,
                    timer: 2000
                });


            }



        },






        btnCancelFuncEnable: function () {

            this.$modal.hide('popupEnable');

        },

        btnCancelFuncDisable: function () {

            this.$modal.hide('popupDisable');

        },


        btnCancelFuncFeatured: function () {

            this.$modal.hide('popupFeatured');

        },

        btnCancelFuncNotFeatured: function () {

            this.$modal.hide('popupNotFeatured');

        },


        enableAds: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "Abilita",
                    html: "Vuoi abilitare gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    var v_token = window.$cookies.get("token");

                    if (result.value == true) {

                        that.$modal.hide('popupEnable');

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("ID_ADS: ", ids);
                        console.log("ID_CMP_SEL: ", that.idsAziSel);


                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.abilitaAds(
                            ids,
                            that.idsAziSel,
                            v_token
                        ).then(async (res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from abilitaAds", res);


                            that.$swal({
                                icon: "success",
                                text: "Annunci abilitati correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }, 200);




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );






                    }

                });



        },


        enableAdsOld: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "Abilita",
                    html: "Vuoi abilitare gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.$modal.hide('popupEnable');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("V_TOKEN: ", v_token);
                        console.log("ID_COMPANY: ", that.idCompanyEnable);
                        console.log("ID_ADS: ", ids);

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.abilitaAds(
                            ids,
                            v_token
                        ).then(async (res) => {

                            console.log("res from abilitaAds", res);


                            var response2 = await apiads.jobMuleInsertAds(
                                ids,
                            ).then(async (res2) => {

                                console.log("res from jobMuleInsertAds", res2);

                                console.log("azienda selezionata", that.idCompanyEnable);


                                if (that.idCompanyEnable == 7) // lc-service
                                {

                                    var response3 = await apiads.jobMuleLCInsertAds(
                                        ids,
                                    ).then((res3) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleLCInsertAds", res3);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci abilitati correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);


                                    }).catch(err3 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err3);
                                        var msg = err3.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response3);

                                    }

                                    );

                                }


                                if (that.idCompanyEnable == 8) // ariall
                                {

                                    var response4 = await apiads.jobMuleAriallInsertAds(
                                        ids,
                                    ).then((res4) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleAriallInsertAds", res4);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci abilitati correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);



                                    }).catch(err4 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err4);
                                        var msg = err4.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response4);

                                    }

                                    );

                                }





                            }).catch(err2 => {
                                that.$root.$children[0].showProgress = false;
                                console.log(err2);
                                var msg = err2.response.data.Error;

                                that.$swal({
                                    icon: "error",
                                    text: msg,
                                    showConfirmButton: false,
                                    timer: 8000
                                });
                                console.log("Errori", "Non è stato possibile eliminare i dati");
                                console.log("response", response2);

                            }

                            );




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );






                    }

                });



        },

        disableAds: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "Disabilita",
                    html: "Vuoi disabilitare gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.$modal.hide('popupDisable');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("ID_ADS: ", ids);
                        console.log("ID_CMP_SEL: ", that.idsAziSel);


                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.disabilitaAds(
                            ids,
                            that.idsAziSel,
                            v_token
                        ).then(async (res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from disabilitaAds", res);


                            that.$swal({
                                icon: "success",
                                text: "Annunci disabilitati correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }, 200);




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );


                    }

                });



        },


        disableAdsOld: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "Disabilita",
                    html: "Vuoi disabilitare gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.$modal.hide('popupDisable');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("V_TOKEN: ", v_token);
                        console.log("ID_COMPANY: ", that.idCompanyDisable);
                        console.log("ID_ADS: ", ids);

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.disabilitaAds(
                            ids,
                            v_token
                        ).then(async (res) => {

                            console.log("res from disabilitaAds", res);


                            var response2 = await apiads.jobMuleRemoveAds(
                                ids,
                            ).then(async (res2) => {

                                console.log("res from jobMuleRemoveAds", res2);

                                console.log("azienda selezionata", that.idCompanyDisable);


                                if (that.idCompanyDisable == 7) // lc-service
                                {

                                    var response3 = await apiads.jobMuleLCRemoveAds(
                                        ids,
                                    ).then((res3) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleLCRemoveAds", res3);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci disabilitati correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);


                                    }).catch(err3 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err3);
                                        var msg = err3.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response3);

                                    }

                                    );

                                }


                                if (that.idCompanyDisable == 8) // ariall
                                {

                                    var response4 = await apiads.jobMuleAriallRemoveAds(
                                        ids,
                                    ).then((res4) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleAriallRemoveAds", res4);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci disabilitati correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);



                                    }).catch(err4 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err4);
                                        var msg = err4.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response4);

                                    }

                                    );

                                }





                            }).catch(err2 => {
                                that.$root.$children[0].showProgress = false;
                                console.log(err2);
                                var msg = err2.response.data.Error;

                                that.$swal({
                                    icon: "error",
                                    text: msg,
                                    showConfirmButton: false,
                                    timer: 8000
                                });
                                console.log("Errori", "Non è stato possibile eliminare i dati");
                                console.log("response", response2);

                            }

                            );




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );






                    }

                });



        },


        featuredAds: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "Featured",
                    html: "Vuoi rendere featured gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.$modal.hide('popupFeatured');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("ID_ADS: ", ids);
                        console.log("ID_CMP_SEL: ", that.idsAziSel);


                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.urgenteAds(
                            ids,
                            that.idsAziSel,
                            v_token
                        ).then(async (res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from urgenteAds", res);


                            that.$swal({
                                icon: "success",
                                text: "Annunci abilitati come featured correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }, 200);




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );



                    }

                });


        },


        featuredAdsOld: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "Featured",
                    html: "Vuoi rendere featured gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.$modal.hide('popupFeatured');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("V_TOKEN: ", v_token);
                        console.log("ID_COMPANY: ", that.idCompanyFeatured);
                        console.log("ID_ADS: ", ids);

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.urgenteAds(
                            ids,
                            v_token
                        ).then(async (res) => {

                            console.log("res from urgenteAds", res);


                            var response2 = await apiads.jobMuleInsertAds(
                                ids,
                            ).then(async (res2) => {

                                console.log("res from jobMuleInsertAds", res2);

                                console.log("azienda selezionata", that.idCompanyFeatured);


                                if (that.idCompanyFeatured == 7) // lc-service
                                {

                                    var response3 = await apiads.jobMuleLCInsertAds(
                                        ids,
                                    ).then((res3) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleLCInsertAds", res3);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci abilitati come featured correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);


                                    }).catch(err3 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err3);
                                        var msg = err3.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response3);

                                    }

                                    );

                                }


                                if (that.idCompanyFeatured == 8) // ariall
                                {

                                    var response4 = await apiads.jobMuleAriallInsertAds(
                                        ids,
                                    ).then((res4) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleAriallInsertAds", res4);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci abilitati come featured correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);



                                    }).catch(err4 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err4);
                                        var msg = err4.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response4);

                                    }

                                    );

                                }





                            }).catch(err2 => {
                                that.$root.$children[0].showProgress = false;
                                console.log(err2);
                                var msg = err2.response.data.Error;

                                that.$swal({
                                    icon: "error",
                                    text: msg,
                                    showConfirmButton: false,
                                    timer: 8000
                                });
                                console.log("Errori", "Non è stato possibile eliminare i dati");
                                console.log("response", response2);

                            }

                            );




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );






                    }

                });



        },

        notFeaturedAds: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "UnFeatured",
                    html: "Vuoi rendere unfeatured gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {



                        that.$modal.hide('popupNotFeatured');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("ID_ADS: ", ids);
                        console.log("ID_CMP_SEL: ", that.idsAziSel);


                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.nonUrgenteAds(
                            ids,
                            that.idsAziSel,
                            v_token
                        ).then(async (res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from nonUrgenteAds", res);


                            that.$swal({
                                icon: "success",
                                text: "Annunci abilitati come not featured correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }, 200);




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );



                    }

                });



        },


        notFeaturedAdsOld: async function () {

            var that = this;

            that.$swal
                .fire({
                    title: "UnFeatured",
                    html: "Vuoi rendere unfeatured gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.$modal.hide('popupNotFeatured');

                        var v_token = window.$cookies.get("token");

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("V_TOKEN: ", v_token);
                        console.log("ID_COMPANY: ", that.idCompanyNotFeatured);
                        console.log("ID_ADS: ", ids);

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.nonUrgenteAds(
                            ids,
                            v_token
                        ).then(async (res) => {

                            console.log("res from nonUrgenteAds", res);


                            var response2 = await apiads.jobMuleInsertAds(
                                ids,
                            ).then(async (res2) => {

                                console.log("res from jobMuleInsertAds", res2);

                                console.log("azienda selezionata", that.idCompanyNotFeatured);


                                if (that.idCompanyNotFeatured == 7) // lc-service
                                {

                                    var response3 = await apiads.jobMuleLCInsertAds(
                                        ids,
                                    ).then((res3) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleLCInsertAds", res3);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci abilitati come not featured correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);


                                    }).catch(err3 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err3);
                                        var msg = err3.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response3);

                                    }

                                    );

                                }


                                if (that.idCompanyNotFeatured == 8) // ariall
                                {

                                    var response4 = await apiads.jobMuleAriallInsertAds(
                                        ids,
                                    ).then((res4) => {

                                        that.$root.$children[0].showProgress = false;
                                        console.log("res from jobMuleAriallInsertAds", res4);


                                        that.$swal({
                                            icon: "success",
                                            text: "Annunci abilitati come not featured correttamente",
                                            showConfirmButton: false,
                                            timer: 2000
                                        });

                                        setTimeout(() => {

                                            that.dialogMsg = false;
                                            that.setupButtons();

                                            that.hideShowButtons(false);

                                            window.table.ajax.reload();

                                        }, 200);



                                    }).catch(err4 => {
                                        that.$root.$children[0].showProgress = false;
                                        console.log(err4);
                                        var msg = err4.response.data.Error;

                                        that.$swal({
                                            icon: "error",
                                            text: msg,
                                            showConfirmButton: false,
                                            timer: 8000
                                        });
                                        console.log("Errori", "Non è stato possibile eliminare i dati");
                                        console.log("response", response4);

                                    }

                                    );

                                }





                            }).catch(err2 => {
                                that.$root.$children[0].showProgress = false;
                                console.log(err2);
                                var msg = err2.response.data.Error;

                                that.$swal({
                                    icon: "error",
                                    text: msg,
                                    showConfirmButton: false,
                                    timer: 8000
                                });
                                console.log("Errori", "Non è stato possibile eliminare i dati");
                                console.log("response", response2);

                            }

                            );




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );






                    }

                });



        },





        copyText: function () {

            console.log("copyText");

            let textToCopy = this.$refs.textToCopy.$el.querySelector('input');


            console.log("textToCopy: ", textToCopy);


            textToCopy.select();
            document.execCommand("copy");

            this.$modal.hide('popupCopyToClipboard');


        },

        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            window.idCompany = azienda.companyid;

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },

        manageClickAziendeEnable: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziendeEnable = false;

            this.idCompanyEnable = azienda.companyid;

        },


        sendMail: async function () {

            var that = this;

            var txt_body = tinymce.activeEditor.getContent();
            var mail_to = that.mailToAds;

            that.$modal.hide('popupMail');

            console.log("MAIL BODY: ", txt_body);
            console.log("MAIL ADDRESS TO: ", mail_to);

            var v_token = window.$cookies.get("token");

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("TOKEN:", v_token);
            console.log("ID SEL:", ids);


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.sendMail(
                v_token,
                ids,
                txt_body,
                mail_to
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from sendMail", res);

                that.$swal({
                    icon: "success",
                    text: "Mail inviata correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });

                setTimeout(() => {

                    that.dialogMsg = false;
                    that.setupButtons();


                    window.table.ajax.reload();

                    that.hideShowButtons(false);


                }, 200);



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );





        },


        loadPreview: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");


            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("TOKEN:", v_token);
            console.log("ID SEL:", ids);

            console.log("ID ADS SEL:", that.idAdsSel);

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.prevMail(
                v_token,
                ids,
                that.idAdsSel
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from prevMail", res);

                that.mailToAds = res.data.MailTo;


                $(".contpopupmail").show();

                that.$modal.show('popupMail');


                setTimeout(() => {

                    tinymce.init({
                        selector: '#sec_body',  // change this value according to your HTML

                        plugin: 'a_tinymce_plugin',
                        height: "370",
                        mode: "textareas",
                        entity_encoding: "raw",
                        add_unload_trigger: false,
                        remove_linebreaks: false,
                        apply_source_formatting: false,
                        force_br_newlines: true,
                        force_p_newlines: false,
                        forced_root_block: '', // Needed for 3.x

                        a_plugin_option: true,
                        a_configuration_option: 400

                    });

                    setTimeout(() => {
                        tinymce.activeEditor.setContent(res.data.TxtPrevMail);

                    }, 700);

                }, 500);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },

        returnToAds: async function () {

            var that = this;

            console.log("ID ADS SEL: ", that.idAdsSel);

            window.AdsSelId = that.idAdsSel;

            var v_token = window.$cookies.get("token");

            that.idAdsSel = ""; // reset id ads selezionati

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.getAds(
                v_token,
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getAds", res);

                that.listAds = res.data.Ads;

                setTimeout(() => {

                    $(".contpopupads").show();

                    that.$modal.show('popupAds');

                    console.log("ID ADS SEL 2: ", window.AdsSelId);

                    setTimeout(() => {

                        console.log("ID ADS SEL 3: ", window.AdsSelId);

                        // ripristino i checkbox già selezionati

                        var elements = window.AdsSelId.split(",");

                        console.log("ELEMENTS: ", elements);


                        $(".val_status_ads").each(function (index) {

                            console.log(index);

                            console.log("VAL: ", $(this).val());

                            for (var x = 0; x <= elements.length - 1; x++) {

                                if ($(this).val() == elements[x]) {

                                    console.log("ok");

                                    $(this).prop("checked", true);

                                }
                                else {

                                    console.log("no");

                                }

                            }



                        });





                    }, 500);





                }, 300);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },


        sendInvite: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.idAdsSel = ""; // reset id ads selezionati

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.getAds(
                v_token,
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getAds", res);

                that.listAds = res.data.Ads;

                setTimeout(() => {

                    $(".contpopupads").show();

                    that.$modal.show('popupAds');

                }, 300);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },



        sendInviteOld: async function () {

            var that = this;

            $(".contpopupads").show();

            that.$modal.show('popupAds');


        },

        previewMail: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");


            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("TOKEN:", v_token);
            console.log("ID SEL:", ids);


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.prevMail(
                v_token,
                ids,
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from prevMail", res);


                $(".contpopupmail").show();

                that.$modal.show('popupMail');


                setTimeout(() => {

                    tinymce.init({
                        selector: '#sec_body',  // change this value according to your HTML

                        plugin: 'a_tinymce_plugin',
                        height: "370",
                        mode: "textareas",
                        entity_encoding: "raw",
                        add_unload_trigger: false,
                        remove_linebreaks: false,
                        apply_source_formatting: false,
                        force_br_newlines: true,
                        force_p_newlines: false,
                        forced_root_block: '', // Needed for 3.x

                        a_plugin_option: true,
                        a_configuration_option: 400

                    });

                    setTimeout(() => {
                        tinymce.activeEditor.setContent(res.data.TxtPrevMail);

                    }, 700);

                }, 500);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },

        previewMailOld: async function () {

            var that = this;

            $(".contpopupmail").show();

            that.$modal.show('popupMail');


            setTimeout(() => {

                tinymce.init({
                    selector: '#sec_body',  // change this value according to your HTML

                    plugin: 'a_tinymce_plugin',
                    height: "370",
                    mode: "textareas",
                    entity_encoding: "raw",
                    add_unload_trigger: false,
                    remove_linebreaks: false,
                    apply_source_formatting: false,
                    force_br_newlines: true,
                    force_p_newlines: false,
                    forced_root_block: '', // Needed for 3.x

                    a_plugin_option: true,
                    a_configuration_option: 400

                });

                // setTimeout(() => {
                //     tinymce.activeEditor.setContent("prova");

                // }, 700);

            }, 500);





        },


        historyCustomer: async function () {


            var that = this;

            var v_token = window.$cookies.get("token");


            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("TOKEN:", v_token);
            console.log("ID SEL:", ids);


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.customersHistory(
                v_token,
                ids,
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from customersHistory", res);

                if (res.data.Result == "OK") {


                    that.customers_history = res.data.Customers;

                    console.log("ok")

                    setTimeout(() => {

                        $(".contpopuphistory").show();

                        that.$modal.show('popupHistory');

                        console.log("ok2");


                    }, 300);



                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.Errore,
                        showConfirmButton: false,
                        timer: 2000
                    });


                }



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );



        },

        initFilter: async function () {


            var that = this;

            var v_token = window.$cookies.get("token");



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiads.initFilter(
                v_token,
                "Jobmule"
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initFilter", res);


                that.aziende = res.data.companies;

                that.aziende_enable = res.data.companies_enable;

                that.aziende_disable = res.data.companies_enable;

                that.aziende_featured = res.data.companies_enable;

                that.aziende_notfeatured = res.data.companies_enable;


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );



        },

        changeFilterStatus: async function (status) {

            console.log(status);

            this.sheetFilterStatus = false;

            window.curStatus = status;

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },


        changeStatus: async function (status) {

            console.log(status);

            this.sheetChangeStatus = false;

            var that = this;

            var v_token = window.$cookies.get("token");


            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("TOKEN:", v_token);
            console.log("VAL STATUS:", status);
            console.log("ID SEL:", ids);


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicandidate.updateMultiStatus(
                v_token,
                ids,
                status
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from updateMultiStatus", res);

                that.$swal({
                    icon: "success",
                    text: "Stati aggiornati correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });

                setTimeout(() => {

                    that.dialogMsg = false;
                    that.setupButtons();


                    window.table.ajax.reload();


                    that.hideShowButtons(false);


                }, 200);

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );



        },



        hideShowButtonsSelRow: function () {

            var tot = 0;
            var has_url = "";
            var num_cand = 0;

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    tot = tot + 1;

                    has_url = $(this).attr("has-url");

                    num_cand = $(this).attr("num-cand");

                }


            });

            console.log("HAS_URL: ", has_url);

            setTimeout(() => {

                var pulsantis = [];

                if (tot == 0) {

                    pulsantis.push({
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-careers.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        title: "Aggiungi",
                        width: 30,

                    });


                }



                if (tot == 1) {

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/edit-row-careers.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        title: "Modifica",
                        width: 30
                    });


                    if (has_url == 1) {

                        pulsantis.push({
                            text: "Copy Url Ads To Clipboard",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/copt_clip_careers.png",
                            link: "/info",
                            id: "btn_copy_to_clipboard",
                            disabled: false,
                            title: "Copy Url Ads To Clipboard",
                            width: 25
                        });

                    }

                    if (num_cand > 0) {

                        pulsantis.push({
                            text: "Candidature",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/candidature_careers.png",
                            link: "/info",
                            id: "btn_candidature",
                            disabled: false,
                            title: "Candidature",
                            width: 22
                        });


                    }




                }

                if (tot > 0) {


                    pulsantis.push({
                        text: "Copia",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/clona_careers.png",
                        link: "/info",
                        id: "btn_copy",
                        disabled: false,
                        title: "Copia",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Abilita",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/abilita_careers.png",
                        link: "/info",
                        id: "btn_enable",
                        disabled: false,
                        title: "Abilita",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Disabilita",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/disabilita_careers.png",
                        link: "/info",
                        id: "btn_disable",
                        disabled: false,
                        title: "Disabilita",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Featured",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/urgent_careers.png",
                        link: "/info",
                        id: "btn_featured",
                        disabled: false,
                        title: "Featured",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Not Featured",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/normal_careers.png",
                        link: "/info",
                        id: "btn_normal",
                        disabled: false,
                        title: "Not Featured",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/delete-careers.png",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                        title: "Elimina",
                        width: 30
                    });

                }



                this.$root.$children[0].bnavbuttons = pulsantis;



            }, 100);



        },


        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + nome_metodo;

        },

        setupGrid: function () {

            var pointerVue = this;


            var filtri = `<img src='/careers/img/refresh-careers.png' style='border:0!important;' class='selaggiorna' title='Aggiorna' /><img src='/careers/img/aziende-careers.png' style='border:0!important;' class='selazienda' title='Azienda' /><div style="transform: translateY(-1px);margin-left:7px" title='Stato'>
                <ion-select cancel-Text="Chiudi" value='` + window.idStatus + `'  data-id="0"  class="selstato" interface="action-sheet" placeholder=" " title='Stato'><ion-select-option  value=''>Tutti</ion-select-option><ion-select-option value='1'>Abilitato</ion-select-option><ion-select-option value='2'>Disabilitato</ion-select-option><ion-select-option value='3'>Featured</ion-select-option><ion-select-option value='4'>Not featured</ion-select-option></div>`;

            const date = new Date().toJSON().slice(0, 10)


            $(document).ready(function () {

                var v_token = window.$cookies.get("token");

                window.columns = [{
                    data: 'sel_row',
                    orderable: false,
                    searchable: false,
                    name: '',
                    width: '1%',
                },

                // {
                //     data: 'DT_RowIndex',
                //     orderable: false,
                //     searchable: false,
                //     name: '',
                //     width: '0.5%',
                // },

                {
                    data: 'row_id',
                    orderable: false,
                    searchable: false,
                    name: '',
                    width: '0.5%',
                },


                {
                    data: 'enabled',
                    orderable: false,
                    name: 'enabled',
                    width: '1%'
                },

                {
                    data: 'isurgent',
                    orderable: false,
                    name: 'isurgent',
                    width: '1%'
                },

                {
                    data: 'number_ads',
                    orderable: false,
                    name: 'number_ads',
                    width: '0.8%'
                },

                {
                    data: 'date',
                    orderable: true,
                    name: 'date',
                    width: '0.8%'
                },

                {
                    data: 'expired_date',
                    orderable: true,
                    name: 'expired_date',
                    width: '0.8%'
                },

                {
                    data: 'companylogo',
                    orderable: false,
                    name: 'companylogo',
                    width: '3%'
                },


                {
                    data: 'title',
                    orderable: false,
                    name: 'title',
                    width: '3%'
                },

                {
                    data: 'description',
                    orderable: false,
                    name: 'description',
                    width: '3%'
                },

                {
                    data: 'nomeregione',
                    orderable: false,
                    name: 'nomeregione',
                    width: '3%'
                },

                {
                    data: 'nomeprovincia',
                    orderable: false,
                    name: 'nomeprovincia',
                    width: '3%'
                },

                {
                    data: 'nomecomune',
                    orderable: false,
                    name: 'nomecomune',
                    width: '3%'
                },



                {
                    data: 'contract_type',
                    orderable: false,
                    name: 'contract_type',
                    width: '3%'
                },

                {
                    data: 'durata',
                    orderable: false,
                    name: 'durata',
                    width: '3%'
                },

                {
                    data: 'tipo_lavoro',
                    orderable: false,
                    name: 'tipo_lavoro',
                    width: '3%'
                },


                {
                    data: 'candidature',
                    orderable: false,
                    name: 'candidature',
                    width: '3%'
                },





                ];




                window.table = $('#myTable').DataTable({
                    // dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                    //     "<'rows colcontTable'<'col-sm-12 'tr>>" +
                    //     "<'row'<'col-sm-12 col-ok  col-md-12'i><'col-sm-12 col-ok-2  col-md-12'p>>",
                    "pagingType": "simple",
                    responsive: true,
                    "pageLength": window.perpage,

                    processing: false,
                    paging: false,
                    serverSide: false,




                    ajax: {
                        url: pointerVue.getUrlDomainGo("getAnnunci") + '?username=' + v_token,
                        data: function (valori) {

                            console.log("VALORI:", valori);

                            try {
                                window.table.clear().draw();

                            } catch (error) {
                                console.log(error);
                            }

                            window.start_ = window.perpage;

                            valori.start_ = 0;
                            valori.length_ = window.perpage;

                            valori.currDay = window.currDay;
                            valori.currDayTo = window.currDayTo;
                            valori.curStatus = window.curStatus;
                            valori.curPiano = window.curPiano;

                            valori.curSrcText = window.curSrcText;

                            valori.idCompany = window.idCompany;
                            valori.idStatus = window.idStatus;

                            valori.curProd = window.curProd;

                            window.valori = valori;
                            return valori;

                        }

                    },



                    language: {

                        lengthMenu: `<label>Mostra<select name="myTable_length" aria-controls="myTable" class="custom-select custom-select-sm form-control-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="-1">Tutti</option></select>Inserimenti</label>`,

                        paginate: {
                            next: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/next2.png'>",
                            previous: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/previous2.png'>"
                        },

                        "sSearch": " ",
                        processing: '<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                    },
                    "info": "",
                    "fnDrawCallback": function (oSettings) {

                        console.log(oSettings);

                        $("body").tooltip({
                            selector: '[data-toggle="tooltip"]'
                        });
                    },

                    columns: window.columns,

                    "initComplete": function (settings) {

                        console.log(settings);

                        $("#myTable_wrapper").show();
                        $(".spin").hide();

                    },
                    "drawCallback": function (settings) {

                        console.log(settings);

                        $(".spin").hide();

                        setTimeout(function () {

                            pointerVue.showSpinner = false;
                            pointerVue.$root.$children[0].showProgress = false;

                        }, 700);

                        var elements = $('.datetimeBook');
                        elements.each(function () {

                            var id = $(this).data("id");
                            (this).pickerOptions = {
                                buttons: [{
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'switch-btn-cancel',
                                },
                                {
                                    text: 'Done',
                                    cssClass: 'switch-btn-done',
                                    handler: columns => {
                                        console.log("ore minuti id", columns.hour.text, columns.minute.text, id);
                                        var valore = columns.hour.text + ":" + columns.minute.text;

                                        console.log(valore);

                                        $.ajax({
                                            url: pointerVue.getUrlDomain("updateHour"),
                                            data: {
                                                "id": id,
                                                "hour": valore,
                                                "v_user": "ZmFnb3N0b25p"
                                            },
                                            success: function () { }
                                        });

                                    }
                                },
                                ],
                            };
                        });

                        setTimeout(function () {

                            //   $("#myTable_filter").width($("#myTable").width());

                        }, 300);

                        var selects = $('.selectstatus');
                        selects.each(function () {
                            var id = $(this).data("id");

                            console.log("ciaone", $(this).data("id"));

                            $(this).on("ionChange", function (opt) {

                                console.log(opt);

                                $(".spin").show();
                                $.ajax({
                                    url: pointerVue.getUrlDomain("updateStatus"),
                                    data: {
                                        "id": id,
                                        "hour": this.value,
                                        "v_user": "ZmFnb3N0b25p"
                                    },
                                    success: function () {
                                        window.table._fnDraw();
                                    }
                                });

                            });

                        });

                        $(".downloadspinner").hide();

                        // $('.p_valore').number(true, 1, ',', '.');
                        // $('.p_totale').number(true, 2, ',', '.');

                        setTimeout(() => {



                            $('.dt-type-numeric').removeClass('dt-type-numeric');


                        }, 800);
                    }

                });




                //Events
                //START SETUP
                function throttle(f, delay) {
                    var timer = null;
                    return function () {
                        var context = this,
                            args = arguments;
                        clearTimeout(timer);
                        timer = window.setTimeout(function () {
                            f.apply(context, args);
                        },
                            delay || 500);
                    };
                }
                window.loading = 0;
                $("div.dataTables_filter input").unbind();
                $('div.dataTables_filter input').keyup(throttle(function () {
                    window.table.ajax.reload();

                }));
                $('#myTable_wrapper').on('scroll', function () {
                    if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
                        if (window.loading == 0) {
                            $(".spin").show();
                            var valori = window.valori;
                            valori.start_ = window.start_;

                            $.ajax({
                                url: pointerVue.getUrlDomainGo("getAnnunci") + '?username=' + v_token,
                                data: window.valori,
                                success: function (data) {
                                    $(".spin").hide();
                                    window.loading = 0;
                                    window.start_ += window.perpage;

                                    for (let [index, val] of data.data.entries()) {
                                        console.log(index, val);
                                        window.table.row.add(val).draw(false);
                                        //  window.dataset.push(val);
                                    }
                                    console.log(data.data);
                                },
                            });
                        }
                        window.loading = 1;
                    }
                });
                //END

                var search = $(".dataTables_length").clone(true);
                search.attr("id", "final_search");
                $(".table_paginate").prepend(search);

                $("#myTable_wrapper .dt-layout-row").first().find("div").remove();

                $("#myTable_wrapper .dt-layout-end").remove();

                $("#myTable_wrapper .dt-layout-row").first().prepend(`
                <div class="cont_buttons">

                    <div class="text_title">Annunci</div>

                    ` + filtri + `

                </div>
                <div><img src='/careers/img/ricerca.png' style='border:0!important;' class='selricerca' title='Ricerca' /></div>
            `);




                $('body').on('click', '.selazienda', function () {

                    console.log(("EVENTO CLICK SELAZIENDA"));

                    pointerVue.openPopupAziende();

                });


                $(".selricerca").on("click", function (opt) {
                    console.log(opt);

                    pointerVue.textSearch = "";

                    $(".contpopupsearch").show();

                    pointerVue.$modal.show('popupSearch');

                });

                $('body').on('click', '.btn-confirm-search', function () {

                    console.log("ok");

                    window.curSrcText = pointerVue.textSearch;

                    pointerVue.$modal.hide('popupSearch');

                    pointerVue.showSpinner = true;
                    pointerVue.$root.$children[0].showProgress = true;

                    window.table.ajax.reload();


                });

                $('body').on('click', '.btn-cancel-search', function () {

                    console.log("ok");

                    pointerVue.$modal.hide('popupSearch');

                });




                $('body').on('click', '.paginate_button', function () {
                    $(".spin").show();

                });

                $('body').on('click', '.refreshButton', function () {

                    $(".spin").show();
                    window.table._fnDraw();

                });

                $('body').on('click', '.cont_annunci_jobmule tr', function () {


                    console.log("TR-ACTIVE");

                    setTimeout(() => {

                        var row_data = window.table.row(this).data();

                        if (row_data != null) {


                            this.row_selected = row_data;


                            console.log("ROW DATA: ", row_data);


                            var last_id_sel = $("tr.active-row").find(".id_row").attr("data-id");

                            var id_sel = $(this).find(".id_row").attr("data-id");


                            var set_cls_active = 0;

                            if (last_id_sel == "undefined") {
                                set_cls_active = 1;
                            } else {
                                if (last_id_sel != id_sel) {
                                    set_cls_active = 1;
                                }
                            }

                            console.log("ROM IS ACTIVE: ", set_cls_active);



                            console.log("THIS: ", this);

                            var hasClassActive = $(this).hasClass("active-row");

                            if (hasClassActive) {

                                console.log("ACTIVE-ROW");

                                $(this).find(".val_status").prop("checked", false);

                                $(this).removeClass("active-row");


                            }

                            if (!hasClassActive) {

                                console.log("NOT ACTIVE-ROW");

                                $(this).find(".val_status").prop("checked", true);

                                $(this).addClass("active-row");



                            }

                            window.id_par_sel = $("tr.active-row").find(".id_row").attr("data-id");

                            if (window.id_par_sel == undefined) {
                                window.id_par_sel = id_sel;
                            }

                            console.log("ID SELECTED: ", window.id_par_sel);


                            console.log("FIND VAL_STATUS: ", $(this).find(".val_status"));

                            var find_check = $(this).find(".val_status");
                            if (find_check.is(":checked")) {
                                console.log("SELEZIONATO");

                            }

                            if (!find_check.is(":checked")) {
                                console.log("DESELEZIONATO");

                            }


                            pointerVue.hideShowButtonsSelRow();


                        }



                    }, 100);




                });

                // }

                //setup ionic calendar top
                setTimeout(function () {

                    $("body").on("ionChange", ".dateBook", function (opt) {

                        console.log(opt);
                        var date = this.value;
                        //var dateMysql = date.toJSON().slice(0, 19).replace('T', ' ')   ;
                        dateMysql = date.substr(0, 10);

                        console.log(dateMysql);

                        $.ajax({
                            url: "{{ route('smartbook.updateDate') }}",
                            data: {
                                "id": $(this).data("id"),
                                "date": dateMysql
                            },
                        });

                    });

                    $(".selectstatusall").on("ionChange", function (opt) {
                        console.log(opt);
                        $(".spin").show();
                        window.curStatus = this.value;

                        window.table.fnPageChange(0);
                        window.table._fnDraw();

                    });

                    $(".selectpianiall").on("ionChange", function (opt) {
                        console.log(opt);
                        $(".spin").show();
                        window.curPiano = this.value;

                        window.table.fnPageChange(0);
                        window.table._fnDraw();

                    });

                    window.currDay = date;
                    window.currDayTo = date;

                }, 600);

                window.parentiAddedEvents = true;

            });

        },

        hideShowButtons: async function (v_enable) {

            setTimeout(() => {

                var pulsantis = [];

                if (v_enable == false) {

                    pulsantis = [

                        {
                            text: "Add",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/xbox-cross-careers.png",
                            link: "/settings",
                            id: "btn_add",
                            disabled: false,
                            title: "Aggiungi",
                            width: 30
                        },


                    ];

                }

                if (v_enable == true) {

                    pulsantis = [

                        {
                            text: "Add",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/xbox-cross-careers.png",
                            link: "/settings",
                            id: "btn_add",
                            disabled: false,
                            title: "Aggiungi",
                            width: 30,
                        },

                        {
                            text: "Edit",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/usr__NM__icon_edit_row_16.png",
                            class: "inverted",
                            link: "/info",
                            id: "btn_edit",
                            disabled: false,
                            title: "Modifica"

                        },

                        {
                            text: "Delete",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/usr__NM__icon_delete_32.png",
                            class: "inverted",
                            link: "/info",
                            id: "btn_delete",
                            disabled: false,
                            title: "Elimina"

                        },




                    ];

                }

                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },

        setupButtonsGrid: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross.png",
                        class: "inverted",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                    },

                    {
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/usr__NM__icon_edit_row_16.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                    },

                    {
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/usr__NM__icon_delete_32.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                    },

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/dash",
                        id: "btn_exit",
                        disabled: false,
                    },

                ];
                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        setupButtons: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/qrconfirm",
                        id: "btn_qrcode",
                        image: "https://app.smart-book.it/public/smartbook/ICON_3.png",
                        disabled: false,
                    },

                    {
                        text: "Settings",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-settings-64.png",
                        class: "inverted",
                        link: "/settings",
                        id: "btn_settings",
                        disabled: false,
                    },

                    {
                        text: "Info",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-informazioni-482.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_info",
                        disabled: false,
                    },

                    {
                        text: "Pdf",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/sb-export-pdf-50.png",
                        class: "inverted",
                        link: "/pdf",
                        id: "btn_pdf",
                        disabled: false,
                    },

                ];

                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        syncProfile: async function () {
            /*  var token = window.$cookies.get("token");
            var system = window.$cookies.get("system"); */

            //  this.data.days = response.data ;
        },

        btn_add_tms_click() {
            console.log(1);
        },
        /*          onClick() {
      console.log('a phone number was clicked');
    }
,
 */
        reply(par) {
            console.log(par);
        },

        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },

        cloneAds: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.$swal
                .fire({
                    title: "Copia",
                    html: "Vuoi copiare gli annunci selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.cloneAds(
                            ids,
                            v_token
                        ).then((res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from cloneAds", res);


                            that.$swal({
                                icon: "success",
                                text: "Annunci copiati correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }, 200);


                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );


                    }


                });

        },


        deleteRow: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.$swal
                .fire({
                    title: "Elimina",
                    html: "Vuoi eliminare l'elemento selezionato ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_jobmule.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);


                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apiads.deleteAds(
                            ids,
                            v_token
                        ).then((res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from deleteAds", res);

                            that.$swal({
                                icon: "success",
                                text: "Annunci eliminati correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }, 200);

                            // console.log("res from deleteAds", res);

                            // var response2 = await apiads.jobMuleRemoveAds(
                            //     ids,
                            // ).then(async (res2) => {

                            //     console.log("res from jobMuleRemoveAds", res2);


                            //     var response3 = await apiads.jobMuleLCRemoveAds(
                            //         ids,
                            //     ).then(async (res3) => {

                            //         console.log("res from jobMuleLCRemoveAds", res3);


                            //         var response4 = await apiads.jobMuleAriallRemoveAds(
                            //             ids,
                            //         ).then((res4) => {

                            //             that.$root.$children[0].showProgress = false;
                            //             console.log("res from jobMuleAriallRemoveAds", res4);


                            //             that.$swal({
                            //                 icon: "success",
                            //                 text: "Annunci eliminati correttamente",
                            //                 showConfirmButton: false,
                            //                 timer: 2000
                            //             });

                            //             setTimeout(() => {

                            //                 that.dialogMsg = false;
                            //                 that.setupButtons();

                            //                 that.hideShowButtons(false);

                            //                 window.table.ajax.reload();

                            //             }, 200);

                            //         }).catch(err4 => {
                            //             that.$root.$children[0].showProgress = false;
                            //             console.log(err4);
                            //             var msg = err4.response.data.Error;

                            //             that.$swal({
                            //                 icon: "error",
                            //                 text: msg,
                            //                 showConfirmButton: false,
                            //                 timer: 8000
                            //             });
                            //             console.log("Errori", "Non è stato possibile eliminare i dati");
                            //             console.log("response", response4);

                            //         }

                            //         );


                            //     }).catch(err3 => {
                            //         that.$root.$children[0].showProgress = false;
                            //         console.log(err3);
                            //         var msg = err3.response.data.Error;

                            //         that.$swal({
                            //             icon: "error",
                            //             text: msg,
                            //             showConfirmButton: false,
                            //             timer: 8000
                            //         });
                            //         console.log("Errori", "Non è stato possibile eliminare i dati");
                            //         console.log("response", response3);

                            //     }

                            //     );

                            // }).catch(err2 => {
                            //     that.$root.$children[0].showProgress = false;
                            //     console.log(err2);
                            //     var msg = err2.response.data.Error;

                            //     that.$swal({
                            //         icon: "error",
                            //         text: msg,
                            //         showConfirmButton: false,
                            //         timer: 8000
                            //     });
                            //     console.log("Errori", "Non è stato possibile eliminare i dati");
                            //     console.log("response", response2);

                            // }

                            // );







                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );

                    }

                });

        },

    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>
.no-before::before {
    content: none !important;
}


table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {
    margin-right: 0.5em !important;
    display: block !important;
    box-sizing: content-box !important;
    content: "+" !important;
    color: white !important;
    top: 50% !important;
    left: 5px !important;
    height: 1em !important;
    width: 1em !important;
    margin-top: -9px !important;
    border: .15em solid white !important;
    border-radius: 1em !important;
    box-shadow: 0 0 .2em #444 !important;
    text-align: center !important;
    text-indent: 0 !important;
    font-family: "Courier New", Courier, monospace !important;
    line-height: 1em !important;
    background-color: #a4a4b0 !important;
    transform: translate(-16px, 12px) !important;
}


.cont_annunci_jobmule #myTable_wrapper>.dt-layout-row:first-of-type {
    top: 66px;
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border: 1px solid #01adff;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 0px;
}



.contCheck {
    align-items: center !important;
    display: flex !important;
    height: 30px !important;
}

.contpopupenable .cl-checkbox i {
    font-size: 13px !important;
}


.cl-title-center {
    text-align: center !important;
}

.cont-table-ads-jm {
    overflow-x: auto !important;
    overflow-y: hidden;
}

.dataTable tbody tr,
.dataTable tbody tr td {
    vertical-align: middle;
    padding: 6px !important;
}

.pay {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #01adff;

}

.pay a {
    color: #01adff;
    -webkit-transition: background-color 2s ease-out;
    -moz-transition: background-color 2s ease-out;
    -o-transition: background-color 2s ease-out;
    transition: background-color 2s ease-out;

}

.pay a:hover {
    color: #01adff;
}

.plan {
    margin-top: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;

}

.policy {
    text-align: center;
    margin-top: 30px;
}

.version {
    font-size: 10px;
    margin-top: 25px;
    text-align: center;
}

.version span {
    font-size: 13px;
}

.titleproduct {
    font-size: 16px;
    font-size: 16px;
    color: #rgb(245, 207, 46);
    font-weight: 800;

    text-align: center;
    margin-top: 40px;

}

.Absolute-Center {

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
}

.logo {
    text-align: center;
}

.table-responsive {
    max-width: 100vw;
}

ion-items {
    min-width: 60px;

}

ion-items ion-datetime {
    margin-left: 25px;
}

.colcontTable .col-sm-12 {
    padding:
        0px;
}

.selectpianiall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    /* border-radius: 12px; */
    /* min-height: 12px; */
    /* transform: translateY(-2px); */
    background-image: url(/smartb/img/FiltroNucleo.png);
    /* padding: 1px 11px; */
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    transform: translateY(2px);
}


.cont-table-ads-jm .spin {

    display: flex;
    position: absolute;
    z-index: 100;
    min-width: 100vw;
    min-height: 100vh;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}


.cont_annunci_jobmule #myTable {
    margin-right: 3px;
    width: 1700px !important;
    margin-top: 69px;
}

.cont_annunci_jobmule table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control,
.cont_annunci_jobmule table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control {
    padding-left: 25px !important;
    /* padding-bottom: 9px !important; */
}

.cont_annunci_jobmule th {
    padding-left: 5px !important;
}

.cont_annunci_jobmule ion-datetime.dateBook {
    margin-left: 16px;
}

.cont_annunci_jobmule .table-responsive {
    padding: 0px;
    min-width: 80vw;
    max-width: 96vw;
}


.cont_annunci_jobmule #myTable_filter {
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    margin-top: 11px !important;
    background-color: white;
    border-color: #01adff;
}

.cont_annunci_jobmule div.dataTables_wrapper div.dataTables_filter input {
    /* margin-top:5px!important */
}

.cl-date {
    font-size: 10px;
    color: gray;
}


.cont-table-ads-jm .cl-date-ins {
    width: 90px !important
}

.cont-table-ads-jm .cl-date-scad {
    width: 90px !important
}


.cont_annunci_jobmule #myTable_wrapper {
    min-width: initial;
    min-width: 1800px;
    max-width: 1800px;
    width: 1800px;
    font-size: 11px;
    color: black;
    font-weight: bold;

}

.cont_annunci_jobmule .text_title {
    background-color: white !important;
    color: black !important;
    font-weight: bold !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    padding-left: 0px !important;
    font-size: 10px !important;
    min-width: 54px !important
}

.cont_annunci_jobmule .cont_buttons {
    display: flex !important;
    align-items: center !important;
    float: left !important;
    min-width: 95px !important;
    padding-left: 10px !important;
    justify-content: inherit !important;
}

.cont_annunci_jobmule .cl_active {
    display: inline-flex;
    align-items: center;
    min-width: 100%;
    justify-content: center;
}


.cont_annunci_jobmule .cl_checkall {
    padding-left: 1px;
    padding-top: 2px;
}

.cont_annunci_jobmule .checkall {
    width: 13px;
    height: 13px;
}


.cont_annunci_jobmule .val_status {
    width: 10px !important;
}


.cont_annunci_jobmule .selaggiorna {
    max-width: 22px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_annunci_jobmule .selazienda {
    max-width: 28px;
    min-height: 28px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 28px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}



.cont_annunci_jobmule .selricerca {
    max-width: 31px;
    min-height: 31px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-right: 14px !important;
}

.cont_annunci_jobmule .selstato {
    max-width: 22px;
    min-height: 22px;
    margin-left: 2px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 26px;
    background-repeat: no-repeat;
    background-image: url(/careers/img/filtro-careers.png);
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-top: 2px;
}

.cont_annunci_jobmule .cl-candidature {
    text-align: center !important;
    width: 100% !important
}


.closeStatusSheet {
    position: absolute;
    right: 0;
}

.font-row-grid-datetime {
    font-size: 10px !important;
    width: 100px !important;
}

.font-row-grid-datetime-mobile {
    font-size: 10px !important;
    padding: 5px !important;
    width: 100px !important;
}

.cl-date {
    font-size: 10px;
    color: gray;
}

.cl-div-hid {
    display: none;
}

.cont_annunci_jobmule input[type='search'] {
    visibility: hidden;
}

.cont_annunci_jobmule .cand {

    /* background: #a9a8ae; */
    background: #dcdbe0;
    max-width: 34px;
    color: #01adff;
    text-align: center;
    border-radius: 50%;
    padding: 2px;
    font-weight: bolder;
    height: 22px;
    width: 22px;
    font-size: 12px;
    margin: 0 auto;
}

.cont_annunci_jobmule .cl-enabled {
    text-align: center;
    width: 100%;
    margin-left: 3px !important
}

.cont_annunci_jobmule .cl-isurgent {
    text-align: center;
    width: 100%;
    margin-left: 3px !important
}



.btnFeatured,
.btnStatus {
    cursor: pointer;
    transition: transform .2s;
}

.btnFeatured:hover,
.btnStatus:hover {
    transform: scale(1.5);
}

.inputCopy {
    border: 1px solid #abaab0;
    min-width: 120px;
}

.btnCopy {
    border: 1px white;
    background: transparent;

}

.titleads {
    color: red;
}

.imgCont {
    display: flex;
    justify-content: flex-start;
    padding: 5px;
    align-items: center;
    padding-left: 0px !important;

}

/* .imgCont img {
    max-height: 20px;
    height: 22px;
    width: 112px;
} */

.imgCont img {
    max-height: 20px;
    height: 15px;
    width: 93px;
}

.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.itemAzienda {
    margin-left: 15px;
}



@media screen and (max-width: 960px) {

    .cont_annunci_jobmule .cl_active {
        display: contents;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }

    .cont_annunci_jobmule #myTable {
        margin-top: 57px;

    }

    .cont_annunci_jobmule #myTable_filter {
        top: 56px;
        position: fixed;

    }

}

@media screen and (max-width: 1024px) {

    .contIcon {
        display: inherit;
    }



    .cont_annunci_jobmule #myTable {
        max-width: 95vw !important;
        margin-right: 0px;
        min-width: 95vw !important;
        position: relative;
        width: 95vw !important;

    }

    .cont_annunci_jobmule #myTable_filter {
        top: 44px;
        position: fixed;

    }

    .cont_annunci_jobmule .table-responsive {
        padding: 0px;
        min-width: 95vw !important;
        max-width: 95vw !important;
        left: 0px;
        position: fixed;

    }

    .cont_annunci_jobmule #myTable_wrapper {
        min-width: initial;
        min-width: 100vw !important;
        max-width: 100vw !important;
        width: 100vw !important;
        margin-top: 14px !important;
        overflow-x: hidden !important;
    }

    .cont_annunci_jobmule .cl_num {
        margin-left: -2px !important;
    }


    .cont_annunci_jobmule .cl_checkall {
        padding-left: 20px;
        padding-top: 2px;
    }

    .font-row-grid-datetime {
        font-size: 10px !important;
        width: 100px !important;
        display: inline-table !important;
    }

    .cl-txt-minor {
        display: inline;
    }

    .imgCont {
        display: inline;
        justify-content: flex-start;
        padding: 5px;
        align-items: center;
        padding-left: 0px !important;

    }

    .imgCont img {
        max-height: 20px;
        height: 22px;
        width: 112px;
    }

    .cont_annunci_jobmule .cl-candidature {
        display: inline;
    }

    .cont_annunci_jobmule .cand {

        background: #a9a8ae;
        max-width: 34px;
        color: white;
        text-align: center;
        border-radius: 50%;
        padding: 2px;
        font-weight: bolder;
        height: 22px;
        width: 22px;
        cursor: pointer;
        font-size: 12px;
        margin: 0 auto;
        display: inline-block;
    }


    .cont_annunci_jobmule .cl-enabled {
        text-align: center;
        width: 100%;
        margin-left: 5px !important;
        display: inline;
    }

    .cont_annunci_jobmule .cl-isurgent {
        text-align: center;
        width: 100%;
        margin-left: 5px !important;
        display: inline;
    }

    .cont-table-ads-jm .cl-date-scad {
        width: 90px !important;
        display: contents;
    }

}
</style>
